import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "../../lib/api";
import { useApp } from "../../context/AppContext";
import ProductCard from "../../components/store/ProductCard";
import { Page, inputCls } from "../../components/store/ui";

export default function Catalog() {
  const { locale, config, t } = useApp();
  const [sp, setSp] = useSearchParams();
  const [data, setData] = useState({ items: [], total: 0, pages: 1 });
  const params = Object.fromEntries(sp.entries());
  const set = (k, v) => { const n = { ...params, [k]: v }; if (!v) delete n[k]; if (k !== "page") delete n.page; setSp(n); };
  useEffect(() => {
    api.get("/store/products", { params: { market: locale.market, ...params } }).then((r) => setData(r.data)).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sp, locale.market]);
  const page = Number(params.page || 1);
  return (
    <Page kicker={`${data.total} produits · ${locale.market}`} title={t("shop")}>
      <div className="grid lg:grid-cols-[220px_1fr] gap-10">
        <aside className="space-y-8" data-testid="catalog-filters">
          <input data-testid="catalog-search" defaultValue={params.q || ""} placeholder={t("search")} className={inputCls} onKeyDown={(e) => e.key === "Enter" && set("q", e.target.value)} />
          <div>
            <div className="label-xs mb-3">{t("categories")}</div>
            {["", ...config.categories].map((c) => (
              <button key={c || "all"} data-testid={`filter-category-${c || "all"}`} onClick={() => set("category", c)}
                className={`block text-sm py-1 transition-colors ${(params.category || "") === c ? "text-[#C9A96E]" : "text-muted-foreground hover:text-white"}`}>{c || t("all")}</button>
            ))}
          </div>
          <div>
            <div className="label-xs mb-3">{t("brands")}</div>
            {[{ id: "", name: t("all") }, ...config.brands].map((b) => (
              <button key={b.id || "all"} data-testid={`filter-brand-${b.id || "all"}`} onClick={() => set("brand", b.id)}
                className={`block text-sm py-1 ${(params.brand || "") === b.id ? "text-[#C9A96E]" : "text-muted-foreground hover:text-white"}`}>{b.name}</button>
            ))}
          </div>
          <div className="grid grid-cols-2 gap-2">
            <input data-testid="filter-min-price" type="number" placeholder={t("min")} defaultValue={params.min_price} className={inputCls} onBlur={(e) => set("min_price", e.target.value)} />
            <input data-testid="filter-max-price" type="number" placeholder={t("max")} defaultValue={params.max_price} className={inputCls} onBlur={(e) => set("max_price", e.target.value)} />
          </div>
          <label className="flex items-center gap-2 text-sm"><input type="checkbox" data-testid="filter-in-stock" checked={params.in_stock === "true"} onChange={(e) => set("in_stock", e.target.checked ? "true" : "")} /> {t("in_stock")}</label>
          <select data-testid="catalog-sort" value={params.sort || "score"} onChange={(e) => set("sort", e.target.value)} className={inputCls}>
            {["score", "price_asc", "price_desc", "new"].map((s) => <option key={s} value={s}>{t(`sort_${s}`)}</option>)}
          </select>
        </aside>
        <div>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-x-6 gap-y-12" data-testid="catalog-grid">
            {data.items.map((p, i) => <ProductCard key={p.id} p={p} i={i} />)}
          </div>
          {!data.items.length && <p className="text-muted-foreground" data-testid="catalog-empty">Aucun produit ne correspond.</p>}
          {data.pages > 1 && (
            <div className="flex gap-2 mt-12 font-mono text-sm">
              {Array.from({ length: data.pages }, (_, i) => i + 1).map((n) => (
                <button key={n} data-testid={`catalog-page-${n}`} onClick={() => set("page", String(n))} className={`w-9 h-9 border ${n === page ? "border-[#C9A96E] text-[#C9A96E]" : "border-white/10"}`}>{n}</button>
              ))}
            </div>
          )}
        </div>
      </div>
    </Page>
  );
}
